import React from "react"
import { FooterWrapper, FooterContainer } from "../../UIKit/styles"

export default function Navigation({ navLinks = [] }) {
  return (
    <FooterWrapper data-testid="footer">
      <FooterContainer>
      <p>
        This web-based tool has been built for <a href="https://www.zespri.com" target="_blank">
          Zespri</a> by <a href="https://www.gpsit.co.nz" target="_blank">GPS-IT</a>, from an excel version developed by <a href="https://agrilink.co.nz/" target="_blank">Agrilink</a> and <a href="https://www.agribusinessgroup.com/" target="_blank">The AgriBusiness Group</a>.</p>
          </FooterContainer>
    </FooterWrapper>
  );
}
